import styled from 'styled-components';
import { Colors } from '../../constants/Colors';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: ${Colors?.bgLight || '#f2f2f2'};
  padding: 20px;
`;

export const Card = styled.div`
  width: 100%;
  max-width: 520px;
  background: ${Colors?.commons.white || '#fff'};
  border-radius: 12px;
  padding: 18px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
`;

export const Title = styled.h2`
  margin: 0 0 14px 0;
  color: ${Colors?.commons.black || '#111'};
  font-size: 18px;
  font-weight: 700;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 600;
  color: ${Colors?.commons.black || '#222'};
`;

export const Input = styled.input`
  height: 38px;
  border-radius: 8px;
  padding: 0 10px;
  border: 1px solid ${Colors?.commons.gray || '#ddd'};
  outline: none;

  &:focus {
    border-color: ${Colors?.primary || '#111'};
  }
`;

export const Select = styled.select`
  height: 38px;
  border-radius: 8px;
  padding: 0 10px;
  border: 1px solid ${Colors?.commons.gray || '#ddd'};
  outline: none;
  background: #fff;

  &:focus {
    border-color: ${Colors?.primary || '#111'};
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: ${Colors?.commons.gray || '#e9e9e9'};
  margin: 14px 0;
`;

export const ToggleWrap = styled.div`
  display: flex;
  gap: 8px;
`;

export const ToggleButton = styled.button<{ $active?: boolean }>`
  height: 34px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid ${({ $active }) => ($active ? (Colors?.primary[100] || '#111') : (Colors?.commons.gray || '#ddd'))};
  background: ${({ $active }) => ($active ? (Colors?.primary[100] || '#111') : '#fff')};
  color: ${({ $active }) => ($active ? '#fff' : (Colors?.commons.black || '#111'))};
  cursor: pointer;
  font-weight: 700;
  font-size: 12px;

  &:hover {
    opacity: 0.9;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 14px;
`;

export const Helper = styled.p`
  margin: 8px 0 0 0;
  font-size: 12px;
  color: ${Colors?.commons.darkGray || '#666'};
  word-break: break-word;
`;

export const ErrorText = styled.p`
  margin: 10px 0 0 0;
  font-size: 12px;
  color: ${Colors?.secondary || '#d00'};
`;
